<template>
  <f7-row class="wd-100">
    <f7-col width="40">
      <div
        class="wd-100 h-130"
        :style="`background-image: url('/assets/img/otros/diamond-carrito.jpg'); background-position: center; background-repeat: no-repeat; background-size: cover;`" />
        <f7-button href="/diamantes/" outline small>Ver Otros</f7-button>
    </f7-col>
    <f7-col width="60">
      <img src="assets/img/otros/check.png" alt="" width="24" style="position: absolute; right: 15px; top: 10px;">
      <span class="favorite-icon">
        <f7-link @click="eliminarCarrito()">
          <f7-icon class="favorite-color" md="material:delete_forever"></f7-icon>
        </f7-link>
      </span>
      <div class="item-cell wd-100 m-l-0">
         <!-- <div class="item-row">
          <div class="item-cell bold fs-12">ID</div>
          <div class="item-cell fs-12 item-search">{{ storage.carrito[idx].ItemID }}</div>
        </div> -->
        <div class="item-row">
          <div class="item-cell bold fs-12">Forma</div>
          <div class="item-cell fs-12 item-search">{{ storage.carrito[idx].Cut }}</div>
        </div>
        <div class="item-row">
          <div class="item-cell bold fs-12">Carat</div>
          <div class="item-cell fs-12 item-search">{{ storage.carrito[idx].Carat }}</div>
        </div>
        <div class="item-row">
          <div class="item-cell bold fs-12">Claridad</div>
          <div class="item-cell fs-12 item-search">{{ storage.carrito[idx].Clarity }}</div>
        </div>
        <div class="item-row">
          <div class="item-cell bold fs-12">Color</div>
          <div class="item-cell fs-12 item-search">{{ storage.carrito[idx].Color }}</div>
        </div>
        <div class="item-row">
          <div class="item-cell bold fs-12">Corte</div>
          <div class="item-cell fs-12 item-search">{{ storage.carrito[idx].MakeCutGrade }}</div>
        </div>
      </div>
      <div class="m-t-5 p-l-15">
        <span class="bold text-color-madai m-r-10">{{ $helper.str.formatearMoneda(storage.carrito[idx].Price) }}</span>
        <span class="fs-10 p-t-20">IVA INCLUIDO</span>
      </div>
    </f7-col>
  </f7-row>
</template>

<script>
export default {
  props: ['idx'],
  methods: {
    eliminarCarrito () {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.filter(item => item.cve !== itm.cve)
      this.$emit('validar')
    },
    seleccionarMedida (evt) {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.map((item, idx) => {
        if (item.cve === itm.cve) {
          item.medida = evt.target.value
        }
        return item
      })
    }
  }
}
</script>
